import { Capacitor } from '@capacitor/core';

const config = {
    useEmulators: !!process.env.REACT_APP_EMULATORS,
    // Running inside the Capacitor Android/iOS wrapper rather than a browser
    isNativeApp: Capacitor.isNativePlatform(),
    functions: {
        loginInit: 'https://logininit-c4vbm7mqwa-ew.a.run.app',
        loginVerify: 'https://loginverify-c4vbm7mqwa-ew.a.run.app',
        loginVerifyWithCode: 'https://loginverifywithcode-c4vbm7mqwa-ew.a.run.app',
        postLoginVerify: 'https://postloginverify-c4vbm7mqwa-ew.a.run.app',
        createUserInvitation: 'https://createuserinvitation-c4vbm7mqwa-ew.a.run.app',
        deleteUserInvitation: 'https://deleteuserinvitation-c4vbm7mqwa-ew.a.run.app',
        updateUserRole: 'https://updateuserrole-c4vbm7mqwa-ew.a.run.app',
        getGeocodingForPlaceId: 'https://getgeocodingforplaceid-c4vbm7mqwa-ew.a.run.app',
        getSuperUserInfo: 'https://getsuperuserinfo-c4vbm7mqwa-ew.a.run.app',
        search: 'https://search-c4vbm7mqwa-ew.a.run.app',
        getPublicOrganization: 'https://getpublicorganization-c4vbm7mqwa-ew.a.run.app',
        getDataFromToken: 'https://getdatafromtoken-c4vbm7mqwa-ew.a.run.app',
        actionOffer: 'https://actionoffer-c4vbm7mqwa-ew.a.run.app',
        createDealFromForm: 'https://createdealfromform-c4vbm7mqwa-ew.a.run.app',
        addAttachmentsToDeal: 'https://addattachmentstodeal-c4vbm7mqwa-ew.a.run.app',
        getGoogleMapsShortlinkLocation: 'https://getgooglemapsshortlinklocation-c4vbm7mqwa-ew.a.run.app',
        initiatePlanUpdate: 'https://initiateplanupdate-c4vbm7mqwa-ew.a.run.app',
        integrationOauth: 'https://integrationoauth-c4vbm7mqwa-ew.a.run.app',
        syncAccounting: 'https://syncaccounting-c4vbm7mqwa-ew.a.run.app',
        syncAccountingRecord: 'https://syncaccountingrecord-c4vbm7mqwa-ew.a.run.app',
        createOrganization: 'https://createorganization-c4vbm7mqwa-ew.a.run.app',
        deleteOrganization: 'https://deleteorganization-c4vbm7mqwa-ew.a.run.app',
        transferOwnership: 'https://transferownership-c4vbm7mqwa-ew.a.run.app',
    }
}

if (config.useEmulators) {
    config.functions = {
        loginInit: 'http://127.0.0.1:5001/limblogic-aca2c/europe-west1/loginInit',
        loginVerify: 'http://127.0.0.1:5001/limblogic-aca2c/europe-west1/loginVerify',
        loginVerifyWithCode: 'http://127.0.0.1:5001/limblogic-aca2c/europe-west1/loginVerifyWithCode',
        postLoginVerify: 'http://127.0.0.1:5001/limblogic-aca2c/europe-west1/postLoginVerify',
        createUserInvitation: 'http://127.0.0.1:5001/limblogic-aca2c/europe-west1/createUserInvitation',
        deleteUserInvitation: 'http://127.0.0.1:5001/limblogic-aca2c/europe-west1/deleteUserInvitation',
        updateUserRole: 'http://127.0.0.1:5001/limblogic-aca2c/europe-west1/updateUserRole',
        getGeocodingForPlaceId: 'http://127.0.0.1:5001/limblogic-aca2c/europe-west1/getGeocodingForPlaceId',
        getSuperUserInfo: 'http://127.0.0.1:5001/limblogic-aca2c/europe-west1/getSuperUserInfo',
        search: 'http://127.0.0.1:5001/limblogic-aca2c/europe-west1/search',
        getPublicOrganization: 'http://127.0.0.1:5001/limblogic-aca2c/europe-west1/getPublicOrganization',
        getDataFromToken: 'http://127.0.0.1:5001/limblogic-aca2c/europe-west1/getDataFromToken',
        actionOffer: 'http://127.0.0.1:5001/limblogic-aca2c/europe-west1/actionOffer',
        createDealFromForm: 'http://127.0.0.1:5001/limblogic-aca2c/europe-west1/createDealFromForm',
        addAttachmentsToDeal: 'http://127.0.0.1:5001/limblogic-aca2c/europe-west1/addAttachmentsToDeal',
        getGoogleMapsShortlinkLocation: 'http://127.0.0.1:5001/limblogic-aca2c/europe-west1/getGoogleMapsShortlinkLocation',
        initiatePlanUpdate: 'http://127.0.0.1:5001/limblogic-aca2c/europe-west1/initiatePlanUpdate',
        integrationOauth: 'http://127.0.0.1:5001/limblogic-aca2c/europe-west1/integrationOauth',
        syncAccounting: 'http://127.0.0.1:5001/limblogic-aca2c/europe-west1/syncAccounting',
        syncAccountingRecord: 'http://127.0.0.1:5001/limblogic-aca2c/europe-west1/syncAccountingRecord',
        createOrganization: 'http://127.0.0.1:5001/limblogic-aca2c/europe-west1/createOrganization',
        deleteOrganization: 'http://127.0.0.1:5001/limblogic-aca2c/europe-west1/deleteOrganization',
        transferOwnership: 'http://127.0.0.1:5001/limblogic-aca2c/europe-west1/transferOwnership',
    }
}

export default config;